/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_DeleteInputs */

const en_history_delete = /** @type {(inputs: History_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete entry`)
};

const de_history_delete = /** @type {(inputs: History_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintrag löschen`)
};

/**
* | output |
* | --- |
* | "Delete entry" |
*
* @param {History_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_delete = /** @type {((inputs?: History_DeleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_DeleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_delete(inputs)
	return en_history_delete(inputs)
});